export const FORM_LIMIT = Object.freeze({ NAME: 120, DOSE: 80, NOTE: 1000, CHAT: 2000 });
export const TIME_FORMAT = Object.freeze({ INPUT: 'HH:mm', DISPLAY: 'h:mm A' });
export const DATE_FORMAT = Object.freeze({ INPUT: 'YYYY-MM-DD' });
export const TIME_INPUT_PATTERN = '^([01][0-9]|2[0-3]):[0-5][0-9]$';

// Match the API's patient-local datetime schema, including month-specific day ranges.
const DATE_ONLY_PATTERN =
  '\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|02-(?:0[1-9]|1\\d|2\\d))';
export const DATETIME_WITH_TIME_PATTERN = `^${DATE_ONLY_PATTERN}\\s(0\\d|1\\d|2[0-3]):[0-5]\\d:[0-5]\\d$`;
